import React,{useEffect,useState,useContext} from 'react';
import ReactTooltip from 'react-tooltip';
import {  Button } from 'react-bootstrap';
// ListGroup, Container, Row, Col, Modal, Nav,
import {  withRouter } from "react-router-dom";
// Link,
import { apiUrl, user_Status, user_Status_Ver } from "Api/Api";
// , myHeaders_Auth_With_Cache_Control
//import { HubspotForm } from "Api/HubspotApi.js";

import axios from "axios";

// import { local_routes } from 'utils/Routes';

//import Select from 'react-select';

import UserContext from 'store/UserContext';

// import { get_current_unix_stamp } from "utils/Helper"

//import { slugify } from 'utils/Helper';

//import { useForm } from 'react-hubspot'

//import './style.css';

import SignupModal from 'components/Modals/SignupModal';
import VerificationModal from 'components/Modals/VerificationModal';


function EventRegisterButton (props) {
  const user_context = useContext(UserContext);

  const button_info_map = {
    'registered': {
      button_text: 'Join',
      button_tooltip: 'Click to join via Zoom',
      button_variant: 'success',
      button_icon: <i className="fa fa-rocket"/>
    },
    'unregistered': {
      button_text: 'Register',
      button_tooltip: user_context.user_info.entity_uuid ? 'Click to Register via Zoom' : 'Login to Register via Zoom',
      button_variant: 'pkprimary',
      button_icon: <i className="fa fa-plus"/>
    }
  };
  
  const [registered,setRegistered] = useState(props.registered);
  const [button_info,setButtonInfo] = useState(props.registered ? button_info_map['registered'] : button_info_map['unregistered']);
  
  const [join_url,setJoinUrl] = useState(props.join_url || '');
  
  const [show_signup_modal,setShowSignupModal] = useState(false);
  const [verification_modal_show,setVerificationModalShow] = useState(false);

  //console.log("FollowButton",props);


  
  useEffect(() => {
    console.log("EventRegisterButton useEffect",join_url,props);
  });
  

  async function registerZoom () {
    console.log("registerZoom",registered,join_url,props.entity_info);
    
    if (!user_context.user_info.entity_uuid) {
      window.localStorage.setItem('loginOrigin',props.location.pathname);
      setShowSignupModal(true);
      //props.history.push('/login');
      return;
    }

    if (user_context.user_info.status_code !== 1) {
      console.error("NO user is not verified!");
      setVerificationModalShow(true);
      return;
    }

    setButtonInfo(button_info_map.registered);
    setRegistered(true);
    let register_zoom_response = await axios.post(`${apiUrl}events/${props.entity_info.entity_uuid}/registerZoom`,{});
    console.log('YO1',join_url,register_zoom_response.data);
    if (register_zoom_response.data.join_url) {
      console.log('YO2',join_url,register_zoom_response.data.join_url);
      setJoinUrl(register_zoom_response.data.join_url);
    }
  }

  return (
    <React.Fragment>
      { join_url ?
        <React.Fragment>
        <Button
          style={{ marginRight: "5px" }}
          variant="info"
          data-place='top'
          data-tip={'Your are registered for this PechaKucha Zoom Webinar'}
        >
          <i className="fa fa-check"/> Registered
          <ReactTooltip />
        </Button>
        <a
            rel='noopener noreferrer'
            href={join_url}
            target="_blank"
        >
          <Button
            style={{ marginRight: "5px" }}
            variant={button_info.button_variant}
            data-place='top'
            data-tip={button_info.button_tooltip}
          >
            {button_info.button_icon} {button_info.button_text}
            <ReactTooltip />
          </Button>
        </a>
        </React.Fragment>
      :
        <Button
          style={{ marginRight: "5px" }}
          variant={button_info.button_variant}
          data-place='top'
          data-tip={button_info.button_tooltip}
          onClick={registerZoom}
        >
          {button_info.button_icon} {button_info.button_text}
          <ReactTooltip />
        </Button>
      }
      { !user_Status &&
        <SignupModal
          show={show_signup_modal}
          onHide={() => setShowSignupModal(false)}
          reload={true}
        >
        </SignupModal>
      }
        
      { user_Status_Ver !== "1" &&
        <VerificationModal
            show={verification_modal_show}
            onHide={() => setVerificationModalShow(false)}
        />
      
      }
    </React.Fragment>
  );
}

export default withRouter(EventRegisterButton);